import Button from '../../components/ui/Button';
import ticket from '../../assets/icons/ticket.svg';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import TransactionTicketPopup from '../../components/Popup/TransactionTicketPopup ';
import { useState } from 'react';
import getGameImage from '../../utils/getGameImage';
import getGameType from '../../utils/games';

export default function TransactionCard({
  game,
  logo: Logo,
  drawTime,
  drawDate,
  amount,
  user,
  ticketId,
  onTicketLoading,
  bets,
  gameImage,
}) {
  const navigate = useNavigate();
  const [ticketPopup, setTicketPopup] = useState(false);
  const GameImage = getGameImage(getGameType(gameImage));
  const groupedBets = bets?.reduce((acc, bet) => {
    const gameName = bet.Game.game_settings.otherSettings.image;
    if (!acc[gameName]) {
      acc[gameName] = [];
    }
    acc[gameName].push(bet);
    return acc;
  }, {});

  const hasMultipleGames = Object.keys(groupedBets).length > 1;

  return (
    <>
      <div className=' bg-white mt-2.5 rounded-md border'>
        <div className='flex items-start gap-2.5 p-2.5 '>
          {!hasMultipleGames && (
            <img
              src={GameImage}
              width={62}
              height={62}
              className='rounded-lg'
            />
          )}
          {hasMultipleGames && (
            <div className='flex items-center justify-center w-[62px] h-[62px] bg-gray-100 rounded-lg overflow-hidden relative'>
              {Object.keys(groupedBets).length === 1 && (
                <img
                  src={getGameImage(getGameType(Object.keys(groupedBets)[0]))}
                  alt={Object.keys(groupedBets)[0]}
                  width={32}
                  height={32}
                  className='rounded shadow border bg-white mx-auto'
                  title={Object.keys(groupedBets)[0]}
                />
              )}
              {Object.keys(groupedBets).length === 2 && (
                <div className='flex items-center justify-center w-full h-full relative'>
                  <img
                    src={getGameImage(getGameType(Object.keys(groupedBets)[0]))}
                    alt={Object.keys(groupedBets)[0]}
                    width={55}
                    height={55}
                    className='rounded shadow border bg-white z-10'
                    style={{ position: 'absolute', left: '0', top: '0' }}
                    title={Object.keys(groupedBets)[0]}
                  />
                  <img
                    src={getGameImage(getGameType(Object.keys(groupedBets)[1]))}
                    alt={Object.keys(groupedBets)[1]}
                    width={55}
                    height={55}
                    className='rounded shadow border bg-white z-20'
                    style={{ position: 'absolute', left: '7px', top: '7px' }}
                    title={Object.keys(groupedBets)[1]}
                  />
                </div>
              )}
              {Object.keys(groupedBets).length >= 3 && (
                <div className='flex items-center justify-center w-full h-full relative'>
                  {Object.keys(groupedBets)
                    .slice(0, 3)
                    .map((gameName, idx) => (
                      <img
                        key={gameName}
                        src={getGameImage(getGameType(gameName))}
                        alt={gameName}
                        width={32}
                        height={32}
                        className='rounded shadow border bg-white absolute'
                        style={{
                          left: `${idx * 10}px`,
                          zIndex: 10 + idx,
                          top: '15px',
                        }}
                        title={gameName}
                      />
                    ))}
                  {Object.keys(groupedBets).length > 3 && (
                    <span
                      className='absolute flex items-center justify-center bg-blue-200 text-blue-800 rounded-full font-bold text-xs'
                      style={{
                        left: `${3 * 10}px`,
                        top: '15px',
                        width: '32px',
                        height: '32px',
                        zIndex: 20,
                      }}
                    >
                      +{Object.keys(groupedBets).length - 3}
                    </span>
                  )}
                </div>
              )}
            </div>
          )}
          <div className='flex-1'>
            <div className='flex items-center justify-between'>
              {!hasMultipleGames && (
                <h3 className='font-bold text-base'>{game}</h3>
              )}
              {hasMultipleGames && (
                <div className='flex flex-wrap gap-1 mt-1'>
                  {Object.keys(groupedBets).map((gameName) => (
                    <span
                      key={gameName}
                      className='bg-blue-100 text-blue-700 text-[10px] font-semibold px-2 py-0.5 rounded-full border border-blue-300'
                    >
                      {gameName}
                    </span>
                  ))}
                </div>
              )}
              <Button
                className='bg-[#0E64D1] text-white text-xs px-2 p-1.5 rounded-[4px]'
                text='View ticket'
                onClick={() => setTicketPopup(true)}
              />
            </div>

            <div className='grid grid-cols-3 mt-4 gap-2'>
              <div>
                <div className='text-[10px] text-gray-600'>Draw Time</div>
                <div className='font-semibold text-xs'>{drawTime}</div>
              </div>
              <div>
                <div className='text-[10px] text-gray-600'>Draw Date</div>
                <div className='font-semibold text-xs'>{drawDate}</div>
              </div>
              <div>
                <div className='text-[10px] text-gray-600'>Amount</div>
                <div className='font-semibold text-xs'>₱{amount}</div>
              </div>
            </div>
          </div>
        </div>

        <div className='flex items-center gap-2 px-2 pt-1 text-[#65758B] text-[10px] bg-[#E1E7EF] font-normal border-t border-dashed border-[#65758B] '>
          <User className='h-3.5 w-3.5' />
          User : {user.name} ({user.role})
        </div>

        <div className=' flex items-center gap-2 px-2 pb-1 text-[#65758B] text-[10px] bg-[#E1E7EF] font-normal'>
          <img
            src={ticket}
            alt={game}
            width={14}
            height={14}
            className='rounded-lg'
          />
          Ticket : {ticketId}
        </div>
      </div>

      <TransactionTicketPopup
        isOpen={ticketPopup}
        ticketId={ticketId}
        onClose={() => setTicketPopup(false)}
        onLoading={onTicketLoading}
      />
    </>
  );
}
